<h1 mat-dialog-title>
    Fehlerhafte Scans: {{ fehlerhafteSeiten?.length }}
    {{ isFullScan ? 'Seite(n) manuell korrigieren' : 'Ohrmarke(n) manuell nachtragen' }}
</h1>
<div mat-dialog-content class="dialog-content-root">
    <div class="one-row failed-pages-row">
        <h3>Fehlerhafte Seiten:</h3>
        <ng-container *ngFor="let seite of fehlerhafteSeiten; let i = index">
            <span
                (click)="ladeSeite(i)"
                class="seiten-link failed-page-link"
                [ngClass]="{ 'current-page': seite?.grp_id === aktuelleSeite?.grp_id }"
            >
                {{ seite.seitenzahl }}
            </span>
        </ng-container>
    </div>

    <div class="one-row content-row">
        <div class="viewer-pane">
            <div class="one-row viewer-toolbar">
                <button
                    mat-icon-button
                    matTooltip="Links drehen"
                    (click)="rotateLeft()"
                    [disabled]="!pdfAvailable || isLoading || isSaving"
                >
                    <mat-icon>rotate_left</mat-icon>
                </button>
                <button
                    mat-icon-button
                    matTooltip="Rechts drehen"
                    (click)="rotateRight()"
                    [disabled]="!pdfAvailable || isLoading || isSaving"
                >
                    <mat-icon>rotate_right</mat-icon>
                </button>
                <button
                    mat-stroked-button
                    class="toolbar-button-gap"
                    (click)="resetRotation()"
                    [disabled]="rotation === 0 || !pdfAvailable || isLoading || isSaving"
                >
                    Rotation zurücksetzen
                </button>
                <button
                    mat-icon-button
                    matTooltip="Zoom out"
                    class="toolbar-button-gap-lg"
                    (click)="zoomOut()"
                    [disabled]="!pdfAvailable || isLoading || isSaving || zoomFactor <= 0.5"
                >
                    <mat-icon>zoom_out</mat-icon>
                </button>
                <button
                    mat-icon-button
                    matTooltip="Zoom in"
                    (click)="zoomIn()"
                    [disabled]="!pdfAvailable || isLoading || isSaving || zoomFactor >= 2.5"
                >
                    <mat-icon>zoom_in</mat-icon>
                </button>
                <button
                    mat-stroked-button
                    class="toolbar-button-gap"
                    (click)="resetZoom()"
                    [disabled]="zoomFactor === 1 || !pdfAvailable || isLoading || isSaving"
                >
                    Zoom zurücksetzen
                </button>
                <mat-hint class="zoom-hint">Zoom: {{ zoomPercent }}%</mat-hint>
                <span class="spacer"></span>
            </div>
            <div
                *ngIf="pdfAvailable && pdfSource"
                class="pdf-stage"
            >
                <pdf-viewer
                    [src]="pdfSource"
                    [page]="currentPage"
                    [rotation]="rotation"
                    [show-all]="false"
                    [original-size]="false"
                    [autoresize]="true"
                    [zoom]="zoomFactor"
                    [render-text]="false"
                    class="pdf-single-page"
                ></pdf-viewer>
            </div>
            <mat-spinner *ngIf="!pdfAvailable" style="align-self: center"></mat-spinner>
        </div>
        <div class="form-pane">
            <div class="form-pane-inner">
                <h3 class="form-title">Manuelle Korrektur</h3>
                <p class="form-subtitle">Bitte die Ohrmarke eingeben:</p>
                <div class="one-row form-field-row">
                    <mat-form-field class="ohrmarke-field">
                        <mat-label>Ohrmarke (10-stellig)</mat-label>
                        <span matPrefix class="ohrmarke-prefix">DE</span>
                        <input matInput [formControl]="zifferCtrl" maxlength="10" [disabled]="isSaving || isLoading" />
                    </mat-form-field>
                </div>
                <div class="one-row form-actions-row">
                    <div class="one-row">
                        <span class="spacer"></span>
                        <button
                            *kienePermission="[9374]"
                            mat-stroked-button
                            class="delete-button"
                            color="warn"
                            (click)="openDeleteSeite()"
                            [disabled]="isSaving || isLoading"
                        >
                            <mat-icon>delete</mat-icon> Seite {{ aktuelleSeite.seitenzahl }} l&ouml;schen
                        </button>
                        <button
                            mat-flat-button
                            color="accent"
                            class="save-button"
                            [disabled]="!(zifferCtrl.value?.length === 10) || isSaving || isLoading"
                            (click)="ohrmarkeNachtragen()"
                        >
                            {{ isFullScan ? 'Daten speichern' : 'Ohrmarke nachtragen' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-flat-button color="accent" (click)="dialogRef.close()" [disabled]="isSaving || isLoading"
        >Schlie&szlig;en</button
    >
</div>
